import {SET_VIDEO} from "../../../constants/action-types";

export const setVideo = video => {
    return ({
        type: SET_VIDEO,
        video: video
    });

};
